import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from './apiClient';

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
    const [stores, setStores] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedStoreId, setSelectedStoreIdState] = useState(() => {
        const fromUrl = searchParams.get('store');
        if (fromUrl) return fromUrl;
        return localStorage.getItem('aph-selectedStoreId') || 'all';
    });

    const loadStores = useCallback(async () => {
        try { setStores(await api.stores()); } catch { /* keep the last list */ }
    }, []);

    useEffect(() => { loadStores(); }, [loadStores]);

    const setSelectedStoreId = useCallback((id) => {
        setSelectedStoreIdState(id);
        localStorage.setItem('aph-selectedStoreId', id);
        const next = new URLSearchParams(searchParams);
        next.set('store', id);
        setSearchParams(next, { replace: true });
    }, [searchParams, setSearchParams]);

    return (
        <StoreContext.Provider value={{ stores, selectedStoreId, setSelectedStoreId, reloadStores: loadStores }}>
            {children}
        </StoreContext.Provider>
    );
}

export function useStore() {
    const ctx = useContext(StoreContext);
    if (!ctx) throw new Error('useStore must be used within StoreProvider');
    return ctx;
}
